import { ReportConfig } from "../definitions";

const monthlyProductionReport: ReportConfig = {
  id: "monthlyProductionReport",
  name: "Monthly Production Report",
  options: [],
  layout: [
    {
      items: [
        {
          id: "item-1",
          title: "",
          widgetType: "table",
          headerColumns: [
            { name: "Date", type: "string", align: "center", colSpan: 2 },
            { name: "Quotes", type: "number", align: "center", colSpan: 2 },
            { name: "Written Applications", type: "currency", align: "center", colSpan: 2 },
            { name: "Paid Applications", type: "currency", align: "center", colSpan: 2 },
          ],
          columns: [
            { name: "Year", type: "string", width: "8%" },
            {
              name: "Month",
              type: "map",
              options: {
                1: "January",
                2: "February",
                3: "March",
                4: "April",
                5: "May",
                6: "June",
                7: "July",
                8: "August",
                9: "September",
                10: "October",
                11: "November",
                12: "December",
              },
              align: "right",
              width: "8%",
            },
            { name: "# Quotes", type: "number", width: "14%", align: "right", summary: "sum" },
            { name: "Premiums", type: "currency", width: "14%", align: "right", summary: "sum" },
            { name: "# Apps", type: "number", width: "14%", align: "right", summary: "sum" },
            { name: "Premiums", type: "currency", width: "14%", align: "right", summary: "sum" },
            { name: "# Apps", type: "number", width: "14%", align: "right", summary: "sum" },
            { name: "Premiums", type: "currency", width: "14%", align: "right", summary: "sum" },
          ],
          dataSource: {
            sql: `

declare @startDate date = DATEFROMPARTS(YEAR(GETDATE()), 1, 1);
declare @endDate date = DATEFROMPARTS(YEAR(GETDATE()), 12, 31);

declare @cy numeric = YEAR(GETDATE());

WITH
months AS (
    SELECT @cy as y, 1 AS m
    UNION ALL SELECT @cy, 2
    UNION ALL SELECT @cy, 3
    UNION ALL SELECT @cy, 4
    UNION ALL SELECT @cy, 5
    UNION ALL SELECT @cy, 6
    UNION ALL SELECT @cy, 7
    UNION ALL SELECT @cy, 8
    UNION ALL SELECT @cy, 9
    UNION ALL SELECT @cy, 10
    UNION ALL SELECT @cy, 11
    UNION ALL SELECT @cy, 12
),
YTDApplications AS (
    SELECT
        YEAR([a].[EntryDate]) as [Y],
        MONTH([a].[EntryDate]) as [M],
        COUNT(*) AS ApplicationsWritten,
        SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumWritten
    FROM [awu].[Application] [a]
      LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
      LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    WHERE
      [a].[EntryDate] BETWEEN @startDate and @endDate
      AND st.[ScenarioTypeCode] = 'F'
      AND (@_branch = 0 OR [a].BranchTypeID = @_branch)
    GROUP BY YEAR([a].[EntryDate]), MONTH([a].[EntryDate])
),
YTDPaidApplications AS (
  SELECT
    YEAR([a].[PaidOrClosedDate]) as [Y],
    MONTH([a].[PaidOrClosedDate]) as [M],
    COUNT(*) AS ApplicationsPaid,
    SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumPaid
  FROM [awu].[Application] [a]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
  WHERE
    [a].[PaidOrClosedDate] BETWEEN @startDate and @endDate
    AND st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
    AND (@_branch = 0 OR [a].BranchTypeID = @_branch)
  GROUP BY YEAR([a].[PaidOrClosedDate]), MONTH([a].[PaidOrClosedDate])
),
YTDProposals AS (
    SELECT
    YEAR([p].[CreatedDate]) as [Y],
    MONTH([p].[CreatedDate]) as [M],
    COUNT(*) AS NumberOfQuotes,
    SUM([p].[BenefitAmount]) AS SumOfBenefitAmounts
FROM [dbo].[Proposal] [p]
    INNER JOIN [dbo].[ProposalGroup] AS [pg] ON [p].[ProposalGroupID] = [pg].[ID]
    INNER JOIN [dbo].[Broker] AS [b] ON [pg].[BrokerID] = [b].[ID]
WHERE
    [p].[CreatedDate] BETWEEN @startDate AND @endDate
    AND [p].[IsDeleted] = 0
    AND (@_branch = 0 OR [b].BranchTypeID = @_branch)
GROUP BY YEAR([p].[CreatedDate]), MONTH([p].[CreatedDate])
)

SELECT
    m.y,
    m.m,
    ISNULL([ytdpr].[NumberOfQuotes], 0) AS ProposalsYTD,
    ISNULL([ytdpr].[SumOfBenefitAmounts], 0) AS TotalPremiumProposalsYTD,
    ISNULL([ytd].[ApplicationsWritten], 0) AS ApplicationsWrittenYTD,
    ISNULL([ytd].[TotalPremiumWritten], 0) AS TotalPremiumWrittenYTD,
    ISNULL([ytdp].[ApplicationsPaid], 0) AS ApplicationsPaidYTD,
    ISNULL([ytdp].[TotalPremiumPaid], 0) AS TotalPremiumPaidYTD,
    1 as [Section]

FROM months AS m
    LEFT JOIN YTDApplications [ytd] ON ytd.M = m.m AND ytd.Y = m.y
    LEFT JOIN YTDPaidApplications [ytdp] ON ytdp.M = m.m AND ytdp.Y = m.y
    LEFT JOIN YTDProposals [ytdpr] ON ytdpr.M = m.m AND ytdpr.Y = m.y

-- add summary row
UNION

SELECT
    null,
    null,
    SUM([ytdpr].[NumberOfQuotes]) AS ProposalsYTD,
    SUM([ytdpr].[SumOfBenefitAmounts]) AS TotalPremiumProposalsYTD,
    SUM([ytd].[ApplicationsWritten]) AS ApplicationsWrittenYTD,
    SUM([ytd].[TotalPremiumWritten]) AS TotalPremiumWrittenYTD,
    SUM([ytdp].[ApplicationsPaid]) AS ApplicationsPaidYTD,
    SUM([ytdp].[TotalPremiumPaid]) AS TotalPremiumPaidYTD,
    2

FROM months AS m
    LEFT JOIN YTDApplications [ytd] ON ytd.M = m.m AND ytd.Y = m.y
    LEFT JOIN YTDPaidApplications [ytdp] ON ytdp.M = m.m AND ytdp.Y = m.y
    LEFT JOIN YTDProposals [ytdpr] ON ytdpr.M = m.m AND ytdpr.Y = m.y

ORDER BY section, m.y, m.m

            `,
            returnType: "table",
          },
          options: { summaryInData: true },
        },
      ],
    },
  ],
};

export default monthlyProductionReport;
